module.exports = __webpack_public_path__ + "static/media/simulation-select-time-icon.89299c0f.svg";